// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".random-img[data-v-f5cc1278]{background-position:top}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
